<template>
    <div class="header-container">
        <div class="head-brief-box">
            <div class="head-main-box">
                <div class="brief-box">
                    <div class="web-name-box">
                        <p>湾潮</p>
                        <div class="info-box">
                            <p>时事、财经、生活、部落</p>
                            <p class="web-url">基于微信生态的双域媒体</p>
                        </div>
                    </div>
                    <div class="partner-box">
                        <div class="partner">
                            <p class="p-name">合作伙伴</p>
                            <p class="p-e-name">COOPERATIVE PARTNER</p>
                        </div>
                        <div class="fuhuaqi-box">
                            <a class="fuhuaqi" href="https://www.p2ipo.com" target="_blank">
                                <div class="img-box1">
                                    <img src="https://cdn.bigbays.cn/web/pc/home/p2ipo-logo2x.png" alt="">
                                </div>
                                <p>上市孵化器</p>
                            </a>
                        </div>
                        <div class="shanhaiyuncang-box">
                            <a class="shanhaiyuncang" href="http://www.b2bscm.net/" target="_blank">
                                <div class="img-box2">
                                    <img src="https://cdn.bigbays.cn/web/pc/home/shanhaiyuncang-logo2x.png" alt="">
                                </div>
                                <p>山海云仓</p>
                            </a>
                        </div>
                        <div class="jinwutong-box">
                            <a class="jinwutong" href="http://www.mvcsky.com" target="_blank">
                                <div class="img-box3">
                                    <img src="https://cdn.bigbays.cn/home/cangqiong-logo.png" alt="">
                                    <!-- <img src="https://cdn.bigbays.cn/web/pc/home/jinwutong-logo2x.png" alt=""> -->
                                </div>
                                <p>苍穹系统</p>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="nav-container">
            <div class="nav-main-box">
                <div class="nav-box">
                    <ul>
                        <li v-for="(item, i) in columnList" :key="i" :class="{select: selectFlag == i, active: navFlag == i}"
                            @click="checkNav(i)">
                            <span>{{item.name}}</span>
                            <!-- <i class="icon iconfont icon-xiajiantou1" v-show="i > 0"></i> -->
                        </li>
                        <!-- <li v-for="(item, i) in navList" :key="i" :class="{select: selectFlag == i, active: navFlag == i}"
                            @click="checkNav(i)" @mouseenter="navEnter(i)" @mouseleave="navLeave(i)">
                            <span>{{item.name}}</span>
                            <i class="icon iconfont icon-xiajiantou1" v-show="i > 0"></i>
                        </li> -->
                    </ul>
                    <div class="pull-menu-box" id="pullMenu" :class="{pullmenushow:selectFlag > 0}">
                        <div class="left-menu-view">
                            <div class="left-menu">
                                <ul>
                                    <li v-for="(item, i) in leftMenu" :key="i" :class="{active: i == menuFlag}" 
                                        @click="checkMenu(i)">{{item.name}}</li>
                                </ul>
                            </div>
                        </div>
                        <div class="right-main">
                            <div class="wrap-view">
                                <div class="wraps" id="menuWrap">
                                    <div class="wrap-item" v-for="(item, i) in wrapList" :key="i" @click="goDetailPage()">
                                        <div class="img-box">
                                            <img :src="item.imgUrl" alt="">
                                        </div>
                                        <div class="title">{{item.name}}</div>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="btn-box">
                                <div class="btn" @click="menuWrapNext()" @mouseenter="stopMenuWrap()" @mouseleave="openMenuWrap()">
                                    <i class="icon iconfont icon-zuojiantou1"></i>
                                </div>
                                <div class="btn" @click="menuWrapPrev()" @mouseenter="stopMenuWrap()" @mouseleave="openMenuWrap()">
                                    <i class="icon iconfont icon-zuojiantou2"></i>
                                </div>
                            </div> -->
                        </div>
                    </div>
                </div>
                <div class="right-box">
                    <div class="search-box" v-show="searchBoxShow">
                        <input type="text" id="searchInput" v-model="searchVal">
                        <i class="icon iconfont icon-search" @click="toSearchPage()"></i>
                    </div>
                    <el-popover placement="bottom" trigger="hover">
                        <div style="display:flex;height:140px;">
                            <img :src="homeQrCode" alt="" 
                                style="width:140px;height:140px;margin:auto;">
                        </div>
                        <div class="r-txt" slot="reference" style="margin-left:40px;">关注</div>
                    </el-popover>
                    <el-popover placement="bottom" trigger="hover">
                        <div style="display:flex;height:140px;">
                            <img src="https://cdn.bigbays.cn/pc/home/xiaochengxu-qrcode.jpg" alt="" 
                                style="width:130px;height:130px;margin:auto;">
                        </div>
                        <div class="r-txt" slot="reference">鳳凰社</div>
                    </el-popover>
                    <el-popover placement="bottom" trigger="hover" v-show="!isLogin">
                        <div style="display:flex;height: 260px;overflow: hidden;" id="wxLogin"></div>
                        <div class="r-txt" slot="reference">登录</div>
                    </el-popover>
                    <el-dropdown trigger="click" @command="handleCommand" style="margin-left: 24px;" v-if="isLogin">
                        <el-avatar :size="34" :src="userInfo.avatar?userInfo.avatar:$store.state.defaultAvatar"></el-avatar>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="/userMainIndexP">主页</el-dropdown-item>
                            <el-dropdown-item command="/userIdManageP">个人中心</el-dropdown-item>
                            <el-dropdown-item command="/userContentManageP">创作中心</el-dropdown-item>
                            <el-dropdown-item command="logout">退出登录</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "HeaderComponent",
    data() {
        return {
            // 微信返回二维码参数
            codeInfo: '',
            // 导航栏列表
            navList: [],
            // 导航栏选中项
            navFlag: 0,
            // 导航栏下拉选择项
            selectFlag: 0,
            // 控制导航菜单有没有下拉箭头
            pullArrows: [],
            selShow: false,
            searchVal: '',
            leftMenu: [],
            menuFlag: 0,
            wrapList: [],
            menuWrap: null,
            wrapItemWidth: 230,
            wrapMaxLeft: 0,
            wrapMinLeft: 0,
            wrapNowLeft: 0,
            menuTimer: null
        }
    },
    computed: {
        // 是否为移动端判断
        isMobile() {
            return this.$store.state.isMobile;
        },
        // 是否登录
        isLogin() {
            return this.$store.state.isLogin;
        },
        // 栏目
        columnList() {
            return this.$store.state.columnList;
        },
        // 首页二维码
        homeQrCode() {
            return this.$store.state.homeQrCode;
        },
        // 用户信息
        userInfo() {
            return this.$store.state.userInfo;
        },
        // 搜索框控制
        searchBoxShow() {
            return this.$store.state.headerSearchShow;
        }
    },
    created() {
        // this.openBus();
    },
    mounted() {
        this.getSessionData();
        this.getWxLoginConfig();
        this.setWxLoginCodeStyles();
    },
    methods: {
        openBus() {
            this.Bus.$on('isLogin', res => {
                if(res) {
                    this.getSessionData();
                }
            });
        },
        getArticleList(columnId, flag) {
            if(!this.isMobile) {
                let payload = {
                    column_id: columnId,
                    params:{ limit: 32, page:1 },
                    flag: flag
                };
                this.$store.dispatch('getArticleList', payload);
            }
        },
        /**
         * @function setWxLoginCodeStyles 设置微信登录二维码样式
         */
        setWxLoginCodeStyles() {
            if(document.getElementById('wxLogin')) {
                let parentDom = document.getElementById('wxLogin').parentElement;
                parentDom.style = `display:none;position:absolute;top:188px;left:1063px;
                    transform-origin:center top;padding: 0 !important;background: none;
                    border: none;box-shadow: none;
                `;
            }
        },
        /**
         * @function getWxLoginConfig 获取微信登录信息
         */
        getWxLoginConfig() {
            let flag = document.body.clientWidth > 500;
            if(flag) {
                this.$axios.get(this.Urls.wxLogin).then(res => {
                    let info = res.data.result;
                    this.codeInfo = new WxLogin({
                        self_redirect: false,
                        id: "wxLogin", 
                        appid: info.app_id, 
                        scope: info.scope, 
                        redirect_uri: info.redirect_uri,
                        state: info.state,
                        style: "",
                        href: "https://www.bigbays.cn/static/css/wxcode.css"
                    });
                });
            }
        },
        /**
         * @function getSessionData 获取页面缓存数据
         */
        getSessionData() {
            let data = window.sessionStorage.getItem('navStatus'), index = 0, flag = false;
            if(data) {
                let _data = JSON.parse(data);
                index = _data.index ? _data.index : 0;
                flag = true;
            }
            let timer = setInterval(() => {
                if(this.columnList.length > 0) {
                    clearInterval(timer);
                    this.navFlag = index;
                    let columnId = this.columnList[index].id;
                    this.$store.commit('setLeftMenuBgimg', columnId); // 设置左侧菜单背景图
                    let haveSecond = window.sessionStorage.getItem('leftMenuIndex');
                    if(haveSecond) {
                        let have = Number(JSON.parse(haveSecond).index) >= 0;
                        if(!have) {
                            this.$store.commit('setNavIndex', index);
                            this.getArticleList(columnId, false); // 获取文章列表数据
                            this.$store.dispatch('getAdvArticles', { column_id: columnId }); // 获取广告位文章
                            this.$store.dispatch('getMpwxTrusteeshipList', { column_id: columnId }); // 获取栏目托管公众号
                        }
                    } else {
                        this.$store.commit('setNavIndex', index);
                        this.getArticleList(columnId, false); // 获取文章列表数据
                        this.$store.dispatch('getAdvArticles', { column_id: columnId }); // 获取广告位文章
                        this.$store.dispatch('getMpwxTrusteeshipList', { column_id: columnId }); // 获取栏目托管公众号
                    }
                    if(!flag) {
                        if(i == 0) {
                            this.$router.push({ path: '/' });
                        } else {
                            this.$router.push({ path: '/columnContentListP' });
                        }
                    }
                }
            }, 10);
        },
        /**
         * @function checkNav 选择栏目跳转页面
         * @param { number } i 第i项
         */
        checkNav(...args) {
            let i = args[0];
            this.navFlag = i;
            this.$store.commit('setNavIndex', i);
            let columnId = this.columnList[i].id;
            this.$store.commit('setLeftMenuBgimg', columnId); // 设置左侧菜单背景图
            this.getArticleList(columnId, false); // 获取文章列表数据
            this.$store.dispatch('getAdvArticles', { column_id: columnId }); // 获取广告位文章
            this.$store.dispatch('getMpwxTrusteeshipList', { column_id: columnId }); // 获取栏目托管公众号
            if(!args[1]) {
                if(i == 0) {
                    this.$router.push({ path: '/' });
                } else {
                    this.$router.push({ path: '/columnContentListP' });
                }
            }
            this.$store.commit('setLeftMenuParams', -1);
        },
        navEnter(i) {
            this.selectFlag = i;
            if(i > 0) {
                this.leftMenu = this.navList[i].children;
                this.wrapList = [
                    {
                        name: 'valve的index VR社保在全球范围内售馨 官方将在近期捕获',
                        imgUrl: 'https://cdn.bigbays.cn/test/imgs/timg1.png'
                    },
                    {
                        name: '《漫威复仇者》游戏开发方认为游戏会引起粉丝争议',
                        imgUrl: 'https://cdn.bigbays.cn/test/imgs/timg2.png'
                    },
                    {
                        name: '《莫比乌斯：最终幻想》6月30日全球范围关服',
                        imgUrl: 'https://cdn.bigbays.cn/test/imgs/timg3.png'
                    },
                    {
                        name: '《莫比乌斯：最终幻想》6月30日全球范围关服',
                        imgUrl: 'https://cdn.bigbays.cn/test/imgs/timg6.png'
                    },
                    {
                        name: '《莫比乌斯：最终幻想》6月30日全球范围关服',
                        imgUrl: 'https://cdn.bigbays.cn/test/imgs/timg6.png'
                    }
                ];
                document.getElementById('pullMenu').addEventListener('mouseenter', (ev) => {
                    this.selShow = true;
                });
            }
        },
        navLeave(i) {
            this.selectFlag = -1;
            setTimeout(() => {
                if(!this.selShow && i > 0) {
                    this.selShow = false;
                }
                if(this.selShow) {
                    this.selectFlag = i;
                    document.getElementById('pullMenu').addEventListener('mouseleave', (ev) => {
                        this.selShow = false;
                        this.selectFlag = -1;
                    });
                }
            }, 0);
        },
        checkMenu(i) {
            this.menuFlag = i;
        },
        openMenuWrap() {
            if(this.wrapList.length >= 4) {
                this.menuTimer = setInterval(() => {
                    this.menuWrapNext();
                }, 1500);
            }
        },
        menuWrapNext() {
            this.wrapNowLeft += this.wrapItemWidth;
            this.menuWrap.style.left = -(this.wrapNowLeft) + 'px';
            this.menuWrap.style.transition = 'left .5s';
            if(this.wrapNowLeft >= this.wrapMaxLeft) {
                setTimeout(() => {
                    this.wrapNowLeft = this.wrapList.length / 3 * this.wrapItemWidth;
                    this.menuWrap.style.left = -(this.wrapNowLeft) + 'px';
                    this.menuWrap.style.transition = 'none';
                }, 500);
            }
        },
        menuWrapPrev() {
            this.wrapNowLeft -= this.wrapItemWidth;
            this.menuWrap.style.left = -(this.wrapNowLeft) + 'px';
            this.menuWrap.style.transition = 'left .5s';
            if(this.wrapNowLeft <= this.wrapMinLeft) {
                setTimeout(() => {
                    this.wrapNowLeft = (this.wrapList.length / 3 * 2 * this.wrapItemWidth) - (this.wrapItemWidth * 4);
                    this.menuWrap.style.left = -(this.wrapNowLeft) + 'px';
                    this.menuWrap.style.transition = 'none';
                }, 500);
            }
        },
        stopMenuWrap() {
            this.selectFlag = 0;
            clearInterval(this.menuTimer);
        },
        goDetailPage() {
            // document.getElementById('pullMenu').style.height = '0px';
            // document.getElementById('pullMenu').style.transition = 'height .3s';
            // this.selShow = false;
            // this.stopMenuWrap();
            this.$router.push({ path: '/articleDetailP' });
        },
        /**
         * @function toSearchPage 去搜索页
         */
        toSearchPage() {
            this.$router.push({
                path: '/searchPageP',
                query: {
                    value: this.searchVal
                }
            });
        },
        /**
         * @function handleCommand 用户下拉菜单点击事件
         * @param { string } command 点击项参数
         */
        handleCommand(command) {
            if(command == 'logout') {
                // 退出登录
                window.sessionStorage.clear();
                window.localStorage.clear();
                // window.localStorage.setItem('token', '');
                this.$store.commit('setLoginStatus', false);
                this.cm.notificationShow('提示', '退出登录成功', 300);
            } else {
                let obj = {};
                switch (command) {
                    case '/userIdManageP':
                        obj = { menuIndex: 1, childIndex: 0 };
                        break;
                    case '/userContentManageP':
                        obj = { menuIndex: 2, childIndex: 4 };
                        break;
                    default:
                        obj = { menuIndex: 0, childIndex: -1 };
                        break;
                }
                this.$store.commit('setUserLeftStatus', obj);
                this.$router.push({ path: command });
            }
        }
    },
    destroyed() {
        clearInterval(this.menuTimer);
    }
}
</script>
<style lang="scss" scoped>
@import './HeaderComponent.scss';
</style>
<style lang="scss">
@media screen and(min-width: 500px) {
    .el-popper {
        padding: 5px 0 !important;
        z-index: 9999 !important;
    }
    #wxLogin {
        // width: calc(100% - 15px);
        // padding-left: 15px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/pc/common/header/HeaderComponent.vue